import Head from 'next/head';
import React, {useContext} from 'react';
import {Page} from '../constant/page';
import {PageAppContext} from '../context';

interface IProps {
  page: Page;
  title: string;
}

export default function MetaTitle({page, title}: IProps) {
  const context = useContext(PageAppContext);
  if (context.page === page) {
    return (
      <Head>
        <title key="title">{title}</title>
        <meta name="twitter:title" content={title} />
        <meta property="og:title" content={title} />
      </Head>
    );
  } else {
    return null;
  }
}
